import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  progressCircle: {
    position: 'relative',
    display: 'grid',

    '& > svg': {
      zIndex: 1,
      width: '14px',
      height: '14px',

      '@media screen and (min-width: 1441px)': {
        width: '16px',
        height: '16px',
      },
    },
  },
}));

export default useStyles;
